import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate, useParams } from 'react-router';
import { Center } from '@astryxdesign/core/Center';
import { Spinner } from '@astryxdesign/core/Spinner';
import { StudioLayout } from './StudioLayout';
import { HomePage } from '../pages/HomePage';
import { ServicesPage } from '../pages/ServicesPage';
import { MyBookingPage } from '../pages/MyBookingPage';
import { AssistantPage } from '../pages/AssistantPage';
import { LandingPage } from '../pages/LandingPage';

// the cabinet is a separate chunk: clients never download it
const OwnerApp = lazy(() => import('../owner/OwnerApp'));

function OwnerRoute() {
  return (
    <Suspense
      fallback={
        <Center height="100dvh">
          <Spinner size="xl" />
        </Center>
      }
    >
      <OwnerApp />
    </Suspense>
  );
}

function BookRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/s/${slug}/?book=service`} replace />;
}

export const router = createBrowserRouter([
  { path: '/', element: <LandingPage /> },
  {
    path: '/s/:slug',
    element: <StudioLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'services', element: <ServicesPage /> },
      { path: 'my', element: <MyBookingPage /> },
      { path: 'assistant', element: <AssistantPage /> },
      { path: 'book', element: <BookRedirect /> },
      { path: 'owner/*', element: <OwnerRoute /> },
      { path: '*', element: <Navigate to="." replace /> },
    ],
  },
  { path: '*', element: <LandingPage /> },
]);
